module.exports = __webpack_public_path__ + "static/media/onboarding13.3cdaabc4.svg";